"use strict";
// Contentful simplified client types
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentfulLocale = void 0;
var ContentfulLocale;
(function (ContentfulLocale) {
    ContentfulLocale["enUS"] = "en-US";
    ContentfulLocale["es"] = "es";
    ContentfulLocale["zh"] = "zh";
})(ContentfulLocale || (ContentfulLocale = {}));
exports.ContentfulLocale = ContentfulLocale;
//# sourceMappingURL=client.js.map